exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".no-padding{padding-left:10%}.position-no{position:absolute;top:0;right:0;z-index:-1}td,th{text-align:center!important}", ""]);

// exports
